import { memo } from 'react';
import { useIntl } from 'react-intl';
import Spacer from './Spacer.js';
import Text from './Text.js';
import Tooltip from './Tooltip.js';
import useMessages from './useMessages.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function CategoryLabel({
  name
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const messages = useMessages();

  // Primarily here to satisfy the type system -- we will never surface the
  // deletable cookies to users, we'll just always delete them
  if (name === 'delete-if-seen') {
    return null;
  }
  const labelId = messages.labelIds[name];
  const contentId = messages.contentIds[name];
  if (!labelId || !contentId) return null;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Text, {
      children: formatMessage(labelId)
    }), /*#__PURE__*/jsx(Spacer, {
      size: "sm",
      vertical: true
    }), /*#__PURE__*/jsx(Tooltip, {
      content: formatMessage(contentId)
    }), /*#__PURE__*/jsx(Spacer, {
      size: "xs",
      vertical: true
    })]
  });
}
const CategoryLabel$1 = /*#__PURE__*/memo(CategoryLabel);
export { CategoryLabel$1 as default };
//# sourceMappingURL=CategoryLabel.js.map
